export default "__VITE_ASSET__BRav1Fj___"